export default __webpack_public_path__ + "static/illustration-engagement-loop-526f12dd64c475502d0a8975825560d3.svg";